import {
  ApiRoute,
  CreateUserProfile,
  ProfileDetail,
  ProfileDetailSchema,
  UpdateUserProfile,
  User,
  UserSchema,
  getApiRoute
} from "@garther/interfaces";

import { ApiClientConfig, BaseApiClient } from "./base-client";
import { LS_REFERRAL_CODE_KEY } from "./constants";

export class ProfileApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.PROFILE),
      requireAuth: true
    });
  }

  async getMyProfile(): Promise<ProfileDetail | null> {
    const referral = localStorage.getItem(LS_REFERRAL_CODE_KEY);
    return await this.get("me", ProfileDetailSchema, {
      params: { referral },
      requireAuth: true
    });
  }

  async getProfileByUserId(userId: string): Promise<ProfileDetail | null> {
    return await this.get(userId, ProfileDetailSchema, {
      requireAuth: false
    });
  }

  // Convenience methods for current user (recommended)
  async create(profileData: CreateUserProfile): Promise<User> {
    return await this.post("me", UserSchema, profileData, {
      requireAuth: true
    });
  }

  async updateMyProfile(updateData: UpdateUserProfile): Promise<ProfileDetail> {
    return await this.put("me", ProfileDetailSchema, updateData, {
      requireAuth: true
    });
  }

  // async deleteMyProfile(): Promise<void> {
  //   return await this.delete("me", z.void(), { requireAuth: true });
  // }

  async setAvatar(avatarUrl: string): Promise<ProfileDetail> {
    return this.patch("me/avatar", ProfileDetailSchema, { avatar: avatarUrl });
  }
}
